import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';

import Logger from '../functions/logging';
import '../static/mpaa.css';
import VoxpopmeDisclaimer from '../assets/video-response/vox-dislaimer-top-icon.png';

import FadeIn from '../components/global/FadeIn';
import Feedback from '../components/global/Feedback';
import PageLoader from '../components/global/PageLoader';

import * as auth from '../functions/auth';
import * as TargetProcess from '../functions/targetProcess';

import register from '../api/register';
import login from '../api/login';
import { getUser, updateUserDisclaimer } from '../api/user';
import { groupJoinSubscription, groupSubscribe } from '../api/group';
import { setTargetParams, setCurrentUser, setUserDisclaimer } from '../redux/actions/index';

import localeMessages from '../locales/register';
import { getLanguageWithoutRegionCode, getLocale } from '../functions/locale';

import SessionStatus from '../analytics/analytics-events/SessionStatus';
import { SessionStatusEvent } from '../analytics/analytics-events/constants';
import { VIDEO_RESPONSE_CONSENT } from '../constants/registrationConstants';
import { VIDEO_RELEASE_TERMINATION, WEBCAM_TERMINATION } from '../constants/screenCodes';
import { getViewerMetadata, checkUserAcceptedDisclaimers } from '../functions/helpers';
import { enableFullscreen } from '../functions/fullscreen';


const SUB_PARAMS = ['list', 'group'];
class VideoDisclaimer extends Component {
	constructor(props) {
		super(props);

		this.state = {
			webcamQuestionDisplay: true,
			videoResponseAcceptanceDisplay: false,
			userStudyStatus: null,
			userAcceptedDisclaimer: false,
			intiUserDisclaimer: false,
			ready: false
		};

		this.checkUserCompletionStatus = this.checkUserCompletionStatus.bind(this);
		this.terminateUser = this.terminateUser.bind(this);
		this.acceptVideoDisclaimer = this.acceptVideoDisclaimer.bind(this);
		this.continueStudy = this.continueStudy.bind(this);
	}

	componentDidMount() {
		// get the user object if user_token exists
		let user_token = auth.getToken();
		if (user_token && (!this.props.targetParams || (!this.props.targetParams.partner && !this.props.targetParams.dl))) {
			this.loadUser(user_token);
		}

		if (user_token && this.props.targetParams && (this.props.targetParams.partner || this.props.targetParams.dl)) {
			auth.logout(() => { this.props.setCurrentUser(null); });
		}
		if (this.props.targetParams && this.props.targetParams.fakeUser) {
			this.createUserAuth(this.props.targetParams.fakeUser.email, this.props.targetParams.fakeUser.password);
		}
		else {
			// eslint-disable-next-line react/no-did-mount-set-state
			this.setState({ ready: true });
		}

		if (this.props.currentUser && this.props.targetParams && this.props.targetParams.gid && !this.state.userStudyStatus) {
			this.checkUserCompletionStatus(this.props.currentUser, this.props.targetParams.gid);
		}
	}

	componentDidUpdate() {
		if (this.props.currentUser && this.props.targetParams && this.props.targetParams.gid && !this.state.userStudyStatus) {
			this.checkUserCompletionStatus(this.props.currentUser, this.props.targetParams.gid);
		}

		if (this.props.currentUser
			&& this.props.targetParams
			&& this.props.targetParams.gid
			&& !this.state.intiUserDisclaimer
			&& checkUserAcceptedDisclaimers(this.props.currentUser, this.props.targetParams.gid, VIDEO_RESPONSE_CONSENT)
		) {
			this.setState({ userAcceptedDisclaimer: true, intiUserDisclaimer: true });
		}

		if (this.state.userAcceptedDisclaimer) {
			// this.continueStudy();
		}
	}

	async createUserAuth(userEmail, userPassword) {
		try {
			const result = await login(userEmail, userPassword);
			if (result) {
				Logger.log(this.constructor.name, "createUserAuth() User Login Success", result);
				if (!this.props.targetParams || !this.props.targetParams.fakeUser) auth.setLogin(userEmail);
				if (this.props.targetParams && this.props.targetParams.fakeUser) auth.deletePortalEmail();
				auth.setToken(result);
				this.loadUser(result);
			}
			else {
				Logger.log(this.constructor.name, "createUserAuth() User Login Failed: No result token???");
				let errors = { ...this.state.errors };
				errors["reason"] = this.props.intl.formatMessage(localeMessages.error_login_failed);
				this.setState({ errors: errors, ready: true });
			}
		}
		catch (error) {
			let errors = { ...this.state.errors };
			Logger.log(this.constructor.name, "createUserAuth() User Login Failed", error);
			errors["reason"] = this.props.intl.formatMessage(localeMessages.error_login_failed);
			this.setState({ errors: errors, ready: true });
		}
	}

	async createUser(user, callback) {
		Logger.log(this.constructor.name, "saveUser() user:", user);
		let fields = {
			firstname: user.firstname,
			lastname: user.lastname,
			age: 99,
			gender: "N",
			zipcode: "TEMP",
			email: user.email,
			password: user.password,
			provider: this.props.targetParams && this.props.targetParams.provider ? this.props.targetParams.provider : "NA"
		};

		try {
			const result = await register(fields);
			if (result) {
				Logger.log(this.constructor.name, "createUser() Register Successful", result);
				if (!this.props.targetParams || !this.props.targetParams.fakeUser) auth.setLogin(fields.email);
				auth.setToken(result);
				this.loadUser(result, callback);
			}
			else {
				this.setState({ loading: false });
				Logger.log(this.constructor.name, "createUser() Register Failed: No result token???");
				let errors = { ...this.state.errors };
				errors["status"] = this.props.intl.formatMessage(localeMessages.error_login_failed);
				this.setState({ errors: errors });
			}
		}
		catch (error) {
			this.setState({ loading: false });
			let errors = { ...this.state.errors };
			let reason = error.reason ? error.reason : error.toString();
			Logger.log(this.constructor.name, "createUser() Register Failed", reason, error);
			if (error.error === 403 || error.error === "accounts") {
				errors["status"] = this.props.intl.formatMessage(localeMessages.error_login_incorrect);
			}
			else {
				errors["status"] = this.props.intl.formatMessage(localeMessages.error_register_failed);
			}
			this.setState({ errors: errors });
		}
	}

	async loadUser(user_token, callback) {
		try {
			const result = await getUser(user_token);
			if (result) {
				Logger.log(this.constructor.name, "loadUser() User Success", result);
				this.props.setCurrentUser(result);
				this.setState({ ready: true });
				if (callback) setTimeout(() => { callback(); }, 500);
			}
			else {
				Logger.log(this.constructor.name, "loadUser() User Failed: No result token???");
				let errors = { ...this.state.errors };
				errors["reason"] = this.props.intl.formatMessage(localeMessages.error_study_loading_info);
				this.setState({ errors: errors, ready: true });
			}
		}
		catch (error) {
			let errors = { ...this.state.errors };
			Logger.log(this.constructor.name, "loadUser() User Failed", error);
			errors["status"] = this.props.intl.formatMessage(localeMessages.error_study_loading_info);
			this.setState({ errors: errors, ready: true });
		}
	}

	async setTerminatedUserSubscription(screen_code) {
		let user_token = auth.getToken();
		let user_id = this.props.currentUser.user_id;
		let video_id = this.props.fetchedGroup.video_id;
		let group_id = this.props.fetchedGroup._id;
		let panelSegmentIndex = this.props.targetParams.ps || this.props.targetParams.ps === 0 ? this.props.targetParams.ps.toString() : null;
		let subscribeFn = this.props.targetParams && (this.props.targetParams.partner || this.props.targetParams.dl) ? groupJoinSubscription : groupSubscribe;
		const isTester = TargetProcess.isTester(this.props.targetParams);
		const userLanguageCode = getLocale() || (this.props.targetParams && this.props.targetParams.lang) || getLanguageWithoutRegionCode();

		Logger.log(this.constructor.name, "setTerminatedUserSubscription() suscribe, tester", (this.props.targetParams && (this.props.targetParams.partner || this.props.targetParams.dl)), isTester, this.props.targetParams);
		try {
			const result = await subscribeFn(user_token, user_id, video_id, group_id, panelSegmentIndex, userLanguageCode, 1, screen_code, isTester, true);

			if (result) {
				Logger.log(this.constructor.name, "setTerminatedUserSubscription() Group: ", result);
				this.updateUserVideoDisclaimer(this.props.currentUser, 'decline-video-response', () => { this.setState({ userStudyStatus: "ineligible" }); });
			}
			else {
				Logger.log(this.constructor.name, "setTerminatedUserSubscription() Group Subscription Failed: No result");
				let errors = { ...this.state.errors };
				errors["reason"] = this.props.intl.formatMessage(localeMessages.error_terminating_user);
				this.setState({ errors: errors });
			}
		}
		catch (error) {
			let errors = { ...this.state.errors };
			Logger.log(this.constructor.name, "setTerminatedUserSubscription() Group Subscription Failed", error);
			errors["status"] = this.props.intl.formatMessage(localeMessages.error_terminating_user);
			this.setState({ errors: errors });
		}
	}

	async updateUserVideoDisclaimer(user, videoDisclaimerAction, callback) {
		let user_token = auth.getToken();
		let user_id = this.props.currentUser.user_id;
		let group_id = this.props.fetchedGroup._id;
		let panelSegmentIndex = this.props.targetParams.ps || this.props.targetParams.ps === 0 ? this.props.targetParams.ps.toString() : null;
		let userGroupMetadata = getViewerMetadata(this.props.currentUser, this.props.fetchedGroup);
		let disclaimers = userGroupMetadata && userGroupMetadata.disclaimers && userGroupMetadata.disclaimers.length ? userGroupMetadata.disclaimers : {};

		Logger.log(this.constructor.name, "updateUserVideoDisclaimer() VIDEO RESPONSE: ", videoDisclaimerAction, disclaimers);
		switch (videoDisclaimerAction) {
			case 'accept-video-response': {
				disclaimers[VIDEO_RESPONSE_CONSENT] = true;
				break;
			}
			case 'decline-video-response': {
				disclaimers[VIDEO_RESPONSE_CONSENT] = false;
				break;
			}
		}
 
		let method = userGroupMetadata ? "update" : "create";
		try {
			let result = await updateUserDisclaimer(user_id, user_token, panelSegmentIndex, group_id, disclaimers, userGroupMetadata, method);
			if (result) {
				Logger.log(this.constructor.name, "acceptVideoDisclaimer() Result: ", result);
				if (videoDisclaimerAction === 'accept-video-response') this.setState({ userAcceptedDisclaimer: true });
				if (callback) callback();
			}
			else {
				Logger.log(this.constructor.name, "acceptVideoDisclaimer() Video Disclaimer Failed: No result");
				let errors = { ...this.state.errors };
				errors["reason"] = this.props.intl.formatMessage(localeMessages.error_updating_video_disclaimer);
				this.setState({ errors: errors });
			}
		}
		catch (error) {
			let errors = { ...this.state.errors };
			Logger.log(this.constructor.name, "acceptVideoDisclaimer() Video Disclaimer Failed: No result", error);
			errors["status"] = this.props.intl.formatMessage(localeMessages.error_updating_video_disclaimer);
			this.setState({ errors: errors });
		}
	}

	checkUserCompletionStatus(authedUser, group_id) {
		const { targetParams, globalAnalyticsAdapter } = this.props;
		const isPartner = targetParams && targetParams.partner;
		const isDistList = targetParams && targetParams.dl;
		if (authedUser.subscriptions && authedUser.subscriptions.list && authedUser.subscriptions.group && (authedUser.subscriptions.list.length || authedUser.subscriptions.group.length)) {

			for (let spIndex = 0; spIndex < SUB_PARAMS.length; spIndex++) {
				let subParam = SUB_PARAMS[spIndex];

				for (let i = 0; i < authedUser.subscriptions[subParam].length; i++) {
					let groupSubscription = authedUser.subscriptions[subParam][i];
					if (groupSubscription.group_id === group_id && groupSubscription.complete) {

						const FEEDBACK_REDIRECT = SessionStatusEvent.FEEDBACK_REDIRECT.replace("[type]", 'CompletedChecked');
						let sessionStatus = new SessionStatus(FEEDBACK_REDIRECT, '', '', false, false, true);
						sessionStatus.gaTracker = this.props.tracker;
						sessionStatus.state = isPartner ? 'Partner User' : (isDistList ? 'Distribution List User' : 'Pilotly User');
						sessionStatus.type = isPartner ? targetParams.partner : (isDistList ? targetParams.publisher : 'Pilotly');
						globalAnalyticsAdapter.reportAnalyticsEvent(sessionStatus);

						this.setState({ userStudyStatus: "alreadycompleted" });
						return;

					}
					else if (groupSubscription.group_id === group_id && groupSubscription.screened) {

						const FEEDBACK_REDIRECT = SessionStatusEvent.FEEDBACK_REDIRECT.replace("[type]", 'ScreenedChecked');
						let sessionStatus = new SessionStatus(FEEDBACK_REDIRECT, '', '', false, false, true);
						sessionStatus.gaTracker = this.props.tracker;
						sessionStatus.state = isPartner ? 'Partner User' : (isDistList ? 'Distribution List User' : 'Pilotly User');
						sessionStatus.type = isPartner ? targetParams.partner : (isDistList ? targetParams.publisher : 'Pilotly');
						globalAnalyticsAdapter.reportAnalyticsEvent(sessionStatus);

						this.setState({ userStudyStatus: "ineligible" });
						return;
					}
				}
			}
		}
	}

	terminateUser(screen_code) {
		this.setState({ ready: false });
		if (this.props.currentUser) {
			this.setTerminatedUserSubscription(screen_code);
		}
		else if (this.props.targetParams && (this.props.targetParams.partner || this.props.targetParams.dl) && this.props.targetParams.fakeUser) {
			const terminatedUserSubscription = () => { this.setTerminatedUserSubscription(screen_code); };
			this.createUser(this.props.targetParams.fakeUser, terminatedUserSubscription);
		}
	}

	acceptVideoDisclaimer() {
		this.setState({ ready: false });
		if (this.props.currentUser) {
			this.updateUserVideoDisclaimer(this.props.currentUser, 'accept-video-response', this.continueStudy);
		}
		else if (this.props.targetParams && (this.props.targetParams.partner || this.props.targetParams.dl) && this.props.targetParams.fakeUser) {
			const updateUserVideoDisclaimer = () => { this.updateUserVideoDisclaimer(this.props.currentUser, 'accept-video-response', this.continueStudy); };
			this.createUser(this.props.targetParams.fakeUser, updateUserVideoDisclaimer);
		}
	}

	async continueStudy(route) {
		if (route) {
			this.props.history.push(route);
		}

		if (this.state.userAcceptedDisclaimer && this.props.targetParams && this.props.targetParams.gid && this.props.targetParams.mpaa) {
			this.props.history.push("/mpaa");
		}
		else if (this.state.userAcceptedDisclaimer && this.props.targetParams && this.props.targetParams.gid && this.props.targetParams.userRegistered) {
			//The Web API requestFullscreen() just works when executed by a user interaction. Click or touch.
			await enableFullscreen();
			this.props.history.push("/study");
		}
		else if (this.state.userAcceptedDisclaimer) {
			this.props.history.push("/register");
		}
	}

	render() {
		let webcamQuestionDisplay = this.state.webcamQuestionDisplay;
		let videoResponseAcceptanceDisplay = this.state.videoResponseAcceptanceDisplay;
		let contentType = this.props.fetchedGroup ? this.props.fetchedGroup.content_type : "";

		if (this.state.userStudyStatus) {
			return <Feedback {...this.props} feedbackType={this.state.userStudyStatus} />;
		}

		return (
			<div className="pilotly-register">
				<FadeIn>
					<div className="register-form-wrapper">
						<div className="row ready-to-begin">
							<div className="pb-15 mb-10">
								<img src={VoxpopmeDisclaimer} alt="Voxpopme" />
							</div>

							{webcamQuestionDisplay ?
								<FadeIn>
									<div className="pilotly-register-form p-0">
										<p className="begin-message mb-20">
											You may be asked to provide a video answer to one or more of the questions in this survey. Before we proceed, are you joining this study from a device with web-cam video functionality?
										</p>
										<div className="position-relative mb-10">
											<button className={"waves-effect waves-light btn register-field-submit begin-registration text-capitalize transparent pilotly-home-footer-sign-out-button-no offOnTrans" + (this.state.ready ? " on" : "")}
												onClick={() => this.terminateUser(WEBCAM_TERMINATION)}
												disabled={!this.state.ready}>
												No
											</button>
											<button className={"waves-effect waves-light btn register-field-submit begin-registration text-capitalize mr-10 offOnTrans" + (this.state.ready ? " on" : "")}
												onClick={() => this.setState({ 
													webcamQuestionDisplay: false, 
													videoResponseAcceptanceDisplay: true 
												})}
												disabled={!this.state.ready}>
												Yes
											</button>
											<PageLoader loading={!this.state.ready} small={true} addedClass="transparent-background" />
										</div>
									</div>
								</FadeIn>
								:
								""
							}
							{videoResponseAcceptanceDisplay ?
								<FadeIn>
									<div className="pilotly-register-form p-0">
										<p className="begin-message mb-20">
											A content creator is interested in hearing what consumers think about their {contentType} and would appreciate hearing your comments in a video response.  By agreeing, you to grant Pilotly permission to use these videos for internal research and analysis use only and will remain completely confidential.
										</p>
										<p className="begin-message mb-20">
											We will be using our trusted partner, Voxpopme, to capture the video content. Click <a href="https://www.voxpopme.com/video-question/privacy-policy" target="_blank" rel="noopener noreferrer" style={{ color: "orange" }}>here</a> to view Voxpopme&#39;s Privacy Policy. By clicking the &ldquo;I Agree&rdquo; button below, you are agreeing that you have read this message and have given Pilotly, and our trusted video research partner, Voxpopme, permission to use your video for market research and analysis purposes.
										</p>
										<div className="position-relative mb-10">
											<button className={"waves-effect waves-light btn register-field-submit begin-registration text-capitalize transparent pilotly-home-footer-sign-out-button-no offOnTrans" + (this.state.ready ? " on" : "")}
												onClick={() => this.terminateUser(VIDEO_RELEASE_TERMINATION)}
												disabled={!this.state.ready}>
												I do not agree to share my video
											</button>
											<button className={"waves-effect waves-light btn register-field-submit begin-registration text-capitalize mr-10 offOnTrans" + (this.state.ready ? " on" : "")}
												onClick={() => this.acceptVideoDisclaimer()}
												disabled={!this.state.ready}>
												Yes, I agree to share my video
											</button>
											<PageLoader loading={!this.state.ready} small={true} addedClass="transparent-background" />
										</div>
									</div>
								</FadeIn>
								:
								""
							}
						</div>
					</div>
				</FadeIn>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		currentUser: state.currentUser.currentUser,
		currentUserLocation: state.currentUser.currentUserLocation,
		fetchedDistributionList: state.targetProcess.fetchedDistributionList,
		fetchedGroup: state.targetProcess.fetchedGroup,
		targetParams: state.targetProcess.targetParams,
		userDisclaimer: state.currentUser.userDisclaimer,
		tracker: state.GlobalAnalyticsAdapterReducer.gaTracker,
		globalAnalyticsAdapter: state.GlobalAnalyticsAdapterReducer.globalAnalyticsAdapter,
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
		setTargetParams,
		setCurrentUser,
		setUserDisclaimer
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(VideoDisclaimer));


// WEBPACK FOOTER //
// ./src/pages/VideoDisclaimer.js